<app-organizer-shared-layout-funnel
  class="organizer-activity-sharing-page-share"
  [hasCloseButton]="false"
>
  <app-organizer-shared-page-container>
    <h1 class="organizer-activity-sharing-page-share__title title-2">
      {{ 'activity_sharing.share.title' | translate }}
    </h1>
    <p class="organizer-activity-sharing-page-share__description">
      {{ 'activity_sharing.share.description' | translate }}
    </p>

    <app-sharer-buttons
      *ngIf="isOrganizerShareActivity"
      class="organizer-activity-sharing-page-share__sharer-buttons"
      [description]="
        'activity_sharing.share.sharer_buttons.description' | translate
      "
      [url]="activityUrl"
    ></app-sharer-buttons>

    <app-organizer-shared-navigation-buttons
      [hasPreviousButton]="false"
      [nextDisabled]="false"
      [nextLabel]="
        'activity_sharing.share.navigation_buttons.next_label' | translate
      "
    ></app-organizer-shared-navigation-buttons>
  </app-organizer-shared-page-container>
</app-organizer-shared-layout-funnel>
